import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { from, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { WorkspaceRepository } from '@database/central';
import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { AppRoutingKeys, User } from '@shared';
import { AuthProvider } from './auth.provider';

@Injectable()
export class WorkfileAccessGuard {
	public constructor(
		private navController: NavController,
		private workfileRepository: WorkspaceRepository,
		private authProvider: AuthProvider
	) {}

	/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
	public canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
		const workfileId = _route.paramMap.get(AppRoutingKeys.queryParamsMap.workfileId);

		return from(this.authProvider.getFusionUserId()).pipe(
			switchMap((fusionUserId: string) =>
				this.workfileRepository.getUsers$(workfileId).pipe(
					map((users: User[]) => {
						const userHasAccess = users.find((user: User) => user.userid === fusionUserId);

						if (!userHasAccess) {
							// redirect to import page
							this.navController.navigateRoot(`/${AppRoutingKeys.urlPathImport}`);
							return false;
						}

						return true;
					})
				)
			)
		);
	}
}
